<template>
  <div class="sliding-tabs-container">
    <div class="sliding-tabs" ref="tabsWrapper">
      <div 
        class="sliding-tab"
        v-for="tab in tabs"
        :key="tab.value"
        :class="{ 'active': modelValue === tab.value }"
        @click="switch_tab(tab.value)"
        ref="tabButtons"
      >
        {{ tab.label }}
      </div>
      <!-- Sliding indicator -->
      <div 
        class="sliding-indicator"
        :style="indicatorStyle"
      ></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'SlideTabComponent',
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: (tabs) => {
        return tabs.every(tab => 
          typeof tab === 'object' && 
          tab.hasOwnProperty('label') && // eslint-disable-next-line
          tab.hasOwnProperty('value') // eslint-disable-next-line
        );
      }
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue', 'tab-changed'],
  data() {
    return {
      indicatorStyle: {
        width: '0px',
        left: '0px'
      }
    };
  },
  methods: {
    switch_tab(tabValue) {
      if (this.modelValue !== tabValue) {
        this.$emit('update:modelValue', tabValue);
        this.$emit('tab-changed', tabValue);
        this.update_indicator(tabValue);
      }
    },
    update_indicator(activeTab = null) {
      this.$nextTick(() => {
        const targetTab = activeTab || this.modelValue;
        const activeIndex = this.tabs.findIndex(tab => tab.value === targetTab);
        const activeButton = this.$refs.tabButtons?.[activeIndex];
        
        if (activeButton) {
          this.indicatorStyle = {
            width: activeButton.offsetWidth + 'px',
            left: activeButton.offsetLeft + 'px'
          };
        }
      });
    }
  },
  mounted() {
    // Initialize indicator position
    this.update_indicator();
    
    // Update indicator on window resize
    window.addEventListener('resize', this.update_indicator);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.update_indicator);
  },
  watch: {
    modelValue() {
      this.update_indicator();
    },
    tabs: {
      handler() {
        this.update_indicator();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
.sliding-tabs-container {
  margin-top: 0.5rem;
}

/* The main sliding tab styles are already defined in the global CSS */
</style>
